exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".translationCard-78cbd6a9{margin:20px 20px}.KeyPane-8ce1fbfb{background-color:#FFF5EB;padding:20px 20px;font-size:16px;line-height:22px}.topPane-d84efac6{display:flex;justify-content:space-between;align-items:flex-start}.left-ac71ac4b{height:100%;padding-right:20px;display:flex;flex-flow:column nowrap;flex:1 0 85%}.valueCardInner-261e5b3e{display:flex;align-items:flex-start}.valueCardInner-261e5b3e>span,.valueCardInner-261e5b3e form{flex:1 0 auto}.valueCardInner-261e5b3e>a{flex:0 0 8%}\n", ""]);

// Exports
exports.locals = {
	"translationCard": "translationCard-78cbd6a9",
	"KeyPane": "KeyPane-8ce1fbfb",
	"topPane": "topPane-d84efac6",
	"left": "left-ac71ac4b",
	"valueCardInner": "valueCardInner-261e5b3e"
};